<template>
  <div class="input-tag">

    <form @submit="onSubmit">
      <div class="input-group add-on">

        <ion-grid>

            <ion-row>

            <ion-col v-if="this.showSearchWords == 1" :size-sm="colSizeSm" size="8" class="col-input-tag">
                <ion-searchbar  :value="searchWords"  @click="hideSuggestions"  @ionInput="searchWords = $event.target.value"
                                @keyup="searchKey" placeholder="Suchwort...">

                </ion-searchbar>
            </ion-col>
            <ion-col size="1" class="hidden-desktop" @click="toggleMobileFilter" v-if="this.showSearchWords == 1">
              <ion-icon name="ios-funnel"></ion-icon>
            </ion-col>
            <ion-col size="2" class="hidden-desktop" v-if="this.showSearchWords == 1">
              <ion-icon name="ios-play" class="icon-big" @click="onSubmit"></ion-icon>
            </ion-col>

            <ion-col :size-sm="colSizeSm" size="12" :offset-sm="offsetSm"  class="col-input-tag" v-if="showMobileFilter">
              <div class="selected-tag"  @click="hideSuggestions">
                <div v-for="selectedTag in this.selectedTags" v-bind:key="selectedTag.id"
                     @click="deleteSelectedTag(selectedTag)"
                     class="selected-tag__item">
                  <span v-if="selectedTag.parentParent">
                    {{ selectedTag.parentParent.title }} -&nbsp;
                  </span>
                  <span v-if="selectedTag.parent">
                    {{ selectedTag.parent.title }} -&nbsp;
                   </span>
                  {{ selectedTag.title }}
                  <ion-icon name="close-circle-outline"></ion-icon>
                </div>
              </div>
                <ion-searchbar :value="title"  @ionBlur="hideSuggestions" @ionClear="clearSuggestion"  @click="showTags" @ionInput="title = $event.target.value" @keyup="tagKey" placeholder="Tags eingeben..."></ion-searchbar>
                <ion-list class="suggestion" v-if="this.filterArray.length > 0">
                  <ion-item v-for="filterTag in this.filterArray" v-bind:key="filterTag.id"
                       class="suggestion__item">
                    <span @click="selectSuggestedTag(filterTag, false)" class="suggest__item-title">{{ filterTag.title }}</span> <ion-icon name="add" @click="selectSuggestedTag(filterTag, true)" slot="end" v-if="filterTag.childs && filterTag.childs.length > 0"></ion-icon>
                  </ion-item>
                </ion-list>
            </ion-col>

            <ion-col :size-sm="colSizeSm" size="12"  class="'col-input-tag" v-if="showMobileFilter">
              <div class="selected-tag" @click="hideSuggestions">
                <div v-for="selectedType in this.selectedTypes" :key="selectedType.id" @click="deleteSelectedType(selectedType)"
                     class="selected-tag__item">

                  {{ selectedType.title }}
                  <ion-icon name="close-circle-outline"></ion-icon>
                </div>
              </div>
                <ion-searchbar  v-if="this.showSearchWords == 1" :value="type"  @ionBlur="hideSuggestions" @click="showTypes" @ionInput="type = $event.target.value" @keyup="typeKey"  placeholder="Was wird gesucht?"></ion-searchbar>
              <ion-list class="suggestion" v-if="this.typeArray.length > 0">
                <ion-item v-for="type in this.typeArray" :key="type.id" class="suggestion__item suggestion__item-type" @click="selectSuggestedType(type)">
                  {{ type.title }}
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

        </ion-grid>

      </div>
    </form>

    </div>

</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: "InputTags",
    props: ['showSearchWords'],
    data() {
      return {
        title: "",
        type: "",
        typeArray: [],
        searchWords: "",
        focusTag: {},
        filterArray: [],
        showMobileFilter: true,
      };
    },
    methods: {
      ...mapActions(["getTags", "deleteTag", "setSelectedTags", "addContent", "search", "setSearchWords", "setSelectedTypes", "setErrorMessage"]),
        toggleMobileFilter(){
          this.showMobileFilter = !this.showMobileFilter;
        },
        submitForm(){
            this.$refs.form.submit();
        },
      selectSuggestedTag(selectedTag, showChilds) {
        if(showChilds){
          this.focusTag = selectedTag;
          this.filterArray = this.focusTag.childs;
          this.title = selectedTag.title + '.';
        } else {
          let checkArray = this.selectedTags.filter(function(element){
            return element.id === selectedTag.id;
          });
          if(checkArray.length !== 0) {
            this.setErrorMessage('Dieser Tag wurde bereits ausgewählt.');
            return false;
          } else {
            let title = (this.title != '') ? this.title + '.' + selectedTag.title : selectedTag.title;
            let titleParts = title.split('.');

            let focusTag = this.focusTag;
              if (titleParts.length === 2) {
                selectedTag.parent = this.focusTag;
              }
              if (titleParts.length === 3) {
                selectedTag.parent = this.focusTag;
                this.allTags.forEach(function (tag) {
                  tag.childs.forEach(function (child) {
                    if (child.id === focusTag.id) {
                      selectedTag.parentParent = tag;
                    }
                  });
                });
              }
              let checkArray = this.selectedTags.filter(function (element) {
                return element.id === selectedTag.id;
              });
              if (checkArray.length !== 0) {
                this.setErrorMessage('Dieser Tag wurde bereits ausgewählt.');
                return false;
              } else {
                this.selectedTags.push(selectedTag);
                this.focusTag = {};
                this.title = '';
                this.filterArray = [];
              }

          }

        }
      },
      onSubmit(e) {
        e.preventDefault();

        this.hideSuggestions();
        this.setSearchWords(this.searchWords);
        this.search();
        window.location = '/#/search';
      },
      deleteSelectedTag(tag){
        this.setSelectedTags(this.selectedTags.filter(function(selectedTag){
          return selectedTag.id !== tag.id;
        }));
      },
      deleteSelectedType(type){
        this.setSelectedTypes(this.selectedTypes.filter(function(selectedType){
          return selectedType.id !== type.id;
        }));
      },
      clearSuggestion(){
        this.filterArray = [];
      },
      searchKey(e) {

        if(e.key === 'Enter') {

          this.onSubmit(e);
        }
      },
      hideSuggestions() {
        this.type = '';
        this.typeArray = [];
        this.title = '';
        this.filterArray = [];
      },
      showTags(){
        this.type = '';
        this.typeArray = [];
        this.filterArray = this.allTags;
      },
      tagKey(e) {

        this.title = this.title.toLowerCase();
        this.title = this.title.trim();
        this.title = this.title.replace(/[^\w\säüöß\-\\.]/gi, '');

        let titleParts = this.title.split('.');
        let input = titleParts.slice(-1)[0];
        let tmpParts = [];
        let filterArray = [];
        let focusTag = this.focusTag;

        switch (e.key) {
          case 'Enter':
            this.onSubmit(e);
            break;

          case ' ':

            if (titleParts.length === 1) {
              filterArray = this.allTags.filter(function(element){
                return element.title === input;
              });
            } else {
              filterArray = this.focusTag.childs.filter(function(element){
                return element.title === input;
              });
            }

            if(filterArray.length === 1) {
              let selectedTag = filterArray[0];
              if (titleParts.length === 2) {
                selectedTag.parent = this.focusTag;
              }
              if (titleParts.length === 3) {
                selectedTag.parent = this.focusTag;
                this.allTags.forEach(function (tag) {
                  tag.childs.forEach(function(child){
                    if(child.id === focusTag.id){
                      selectedTag.parentParent = tag;
                    }
                  });
                });
              }
              let checkArray = this.selectedTags.filter(function(element){
                return element.id === filterArray[0].id;
              });
              if(checkArray.length !== 0) {
                this.setErrorMessage('Dieser Tag wurde bereits ausgewählt.');
                return false;
              } else {
                this.selectedTags.push(selectedTag);
                this.focusTag = {};
                this.title = '';
                this.filterArray = [];
              }
            } else {
              this.setErrorMessage('tag does not exist');
              return false;
            }
            break;

          case  '.':
            input = titleParts.slice(-2,-1)[0];

            if (titleParts.length === 2) {
              filterArray = this.allTags.filter(function(element){
                return element.title === input;
              });
            } else {

              filterArray = this.focusTag.childs.filter(function(element){

                return element.title === input;
              });
            }

            if(filterArray.length === 1) {

              let checkArray = this.selectedTags.filter(function(element){
                return element.id === filterArray[0].id;
              });
              if(checkArray.length !== 0) {
                this.setErrorMessage('Dieser Tag wurde bereits ausgewählt.');
                return false;
              } else {
                this.focusTag = filterArray[0];
                this.filterArray = this.focusTag.childs;
              }
            } else {
              this.setErrorMessage('Diesen Tag gibt es nicht.');
              return false;
            }

            break;

          case 'Backspace':
            this.title = '';
            this.focusTag = {};
            this.filterArray = [];
            break;

          default:

            if(this.focusTag.childs) {
              this.filterArray = this.focusTag.childs.filter(function(element){
                return element.title.startsWith(input);
              });
            } else {
              this.filterArray = this.allTags.filter(function(element){
                return element.title.startsWith(input);
              });
            }

            if(this.filterArray.length === 0) {
              this.title = this.title.slice(0, -1);
            }
            if(this.filterArray.length === 1) {

              tmpParts = titleParts.slice(0, (titleParts.length - 1));

              if(titleParts.length === 1) {
                this.title = this.filterArray[0].title;
              } else {
                this.title = tmpParts.join('.') + '.' +this.filterArray[0].title;
              }
              this.filterArray = [];
            }
        }

    },
      showTypes(){
        this.title = '';
        this.filterArray = [];
        this.typeArray = this.allContentTypes;
      },
      selectSuggestedType(selectedType){
        let checkArray = this.selectedTypes.filter(function(element){
          return element.id === selectedType.id;
        });
        if(checkArray.length !== 0) {
          this.setErrorMessage('Dieser Typ wurde bereits ausgwählt.');
          return false;
        } else {
          this.selectedTypes.push(selectedType);
          this.focusTag = {};
          this.type = '';
          this.typeArray = [];
        }
      },
      typeKey(e) {

        this.type = this.type.toLowerCase();
        this.type = this.type.trim();
        this.type = this.type.replace(/[^\w\säüöß\-\\.]/gi, '');

        let input = this.type;
        let typeArray = [];


        switch (e.key) {
          case 'Enter':
            this.onSubmit(e);
            break;

          case ' ':

            typeArray = this.allContentTypes.filter(function(element){

              return element.title.toLowerCase() === input.toLowerCase();
              });

            if(typeArray.length === 1) {
              let selectedType = typeArray[0];

              let checkArray = this.selectedTypes.filter(function(element){
                return element.id === typeArray[0].id;
              });
              if(checkArray.length !== 0) {
                this.setErrorMessage('Dieser Typ wurde bereits ausgwählt.');
                return false;
              } else {
                this.selectedTypes.push(selectedType);
                this.focusTag = {};
                this.type = '';
                this.typeArray = [];
              }
            } else {
              this.setErrorMessage('Diesen Typ gibt es nicht.');
              return false;
            }
            break;
          case 'Backspace':
            this.title = '';
            this.typeArray = [];
            break;

          default:
              this.typeArray = this.allContentTypes.filter(function(element){
                return element.title.startsWith(input);
              });


            if(this.typeArray.length === 0) {
              this.type = this.type.slice(0, -1);
            }
            if(this.typeArray.length === 1) {

                this.type = this.typeArray[0].title;
              }
              this.typeArray = [];

        }
      },
    },
    computed: {
      ...mapGetters(["allTags", "selectedTags", "allContentTypes", "selectedTypes"]),
      colSizeSm() {
        if (this.showSearchWords == 1) {
          return 4;
        }
        else return 6;
      },
      offsetSm() {
        if (this.showSearchWords == 1) {
          return 0;
        }
        else return 3;
      }
    },

    created() {
      this.getTags();
        if( screen.width <= 760  && this.showSearchWords == 1) {
            this.showMobileFilter = false;
        }
        else {
            this.showMobileFilter = true;
        }

    }
  };

</script>

<style scoped>
    .input-tag {
        position: relative;

    }
    .input-tag ion-row{
        background-color: #2E2D2D !important;
    }
    .icon-big {
        font-size: 30px;
        --font-size: 30px;
    }
  ion-searchbar {
    --background: #3E4143;
    --color: white;
    --icon-color: #B6B6B6;
    --border-radius: 35px;
  }

  ion-col {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-flow: column;
      flex-grow: 1;
  }
    @media (min-width: 576px) {
        ion-col {
            align-self: flex-end;
        }
    }

  .suggest__item-title {
    cursor: pointer
  }

  .suggestion__item-type {
    cursor: pointer;
  }

  .selected-tag {
    margin-bottom: 10px;
    min-height: 30px;
    padding-left: 10px;
  }

    @media (max-width: 575px) {
        .selected-tag {
            align-self: baseline;
        }
    }

  .selected-tag__item {
    background-color: #5690BD;
    color: white;
    border-radius: 12px;
    display: inline-flex;
    padding: 5px 10px;
    margin-right: 7px;
    align-items: center;
    cursor: pointer;
  }

  ion-icon {
    margin-left:8px;
    margin-top: 2px;
  }

  .fa-greater-than {
    font-size: 12px;
    margin-right: 5px;
    margin-left: 2px;
    color: #fff;
    margin-top: -1px;
  }

  .suggestion {
    position: absolute;
    background-color: #3E4143;;
    width: calc(100% - 26px);
    margin-left: 8px;
    margin-top: -9px;
    padding: 10px;
    z-index: 1000;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
  }

  .suggestion__item {
    margin-top: 3px;
  }

  .search-button {
    display: none;
  }

  @media all and (display-mode: standalone), screen and (max-width: 768px) {
    .search-button {
      display: block;
      width: calc(100% - 30px);
      margin-left: 15px;
      text-transform: uppercase;
      background-color: #2E2D2D;
      color: #B6B6B6;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    ion-button {
      --background: #3E4143;
      --color: #B6B6B6;
    }

    .selected-tag {
      min-height: 0;
      margin: 0;
    }
  }
</style>
